// extracted by mini-css-extract-plugin
export default {"box":"SwitchMember_box__TnIf8","number":"SwitchMember_number__PqlLZ","active":"SwitchMember_active__UV3S6"};